export const metaFields = /* groq */ `
  metaFields{
    ...,
    twitterImage{
      asset->{
        url
      }
    },
    openImage{
      asset->{
        url
      }
    }
  }
`
